module.exports = __webpack_public_path__ + "b8befb80ef8ba72ccd24983d08513683.png";